/* ============================= */
/* VERSION V1.1 - SECTION SERVICES (B PREMIUM) */
/* ============================= */

// src/components/Services.jsx
import React, { useRef } from "react";
import "../styles/Services.css";
import { FaTrain, FaPlaneDeparture, FaBriefcase, FaRoute } from "react-icons/fa";
import { motion, useScroll, useTransform } from "framer-motion";
import bgServices from "../assets/background/taxi-belfort-toyota-1920.webp";

const servicesData = [
  {
    icon: <FaTrain />,
    title: "Transferts Gare",
    description:
      "Prise en charge et dépose à la gare de Belfort. Ponctualité et organisation simple.",
  },
  {
    icon: <FaPlaneDeparture />,
    title: "Transferts Aéroport",
    description:
      "Aéroport Bâle-Mulhouse et autres aéroports : départ anticipé, trajet confortable, sérénité.",
  },
  {
    icon: <FaRoute />,
    title: "Longue distance",
    description:
      "Déplacements régionaux et nationaux : itinéraire optimisé, confort premium, conduite souple.",
  },
  {
    icon: <FaBriefcase />,
    title: "Business & rendez-vous",
    description:
      "Service discret pour professionnels : ponctualité, confort, communication rapide.",
  },
];

function ServiceCard({ service }) {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 85%", "start 35%"],
  });

  const cardY = useTransform(scrollYProgress, [0, 1], [20, 0]);
  const cardOpacity = useTransform(scrollYProgress, [0, 1], [0.6, 1]);
  const cardScale = useTransform(scrollYProgress, [0, 1], [0.97, 1]);
  const iconScale = useTransform(scrollYProgress, [0, 1], [0.9, 1.05]);

  return (
    <motion.div
      ref={ref}
      className="service-card"
      style={{ y: cardY, opacity: cardOpacity, scale: cardScale }}
      whileHover={{ y: -6, scale: 1.02 }}
      transition={{ type: "spring", stiffness: 260, damping: 22 }}
    >
      <motion.div className="service-icon" style={{ scale: iconScale }}>
        {service.icon}
      </motion.div>

      <h3>{service.title}</h3>
      <p>{service.description}</p>
    </motion.div>
  );
}

const Services = () => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  const bgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="services" ref={sectionRef} className="services-section" aria-labelledby="services-title">
      {/* Background layer */}
      <motion.div
        className="services-bg"
        style={{ backgroundImage: `url(${bgServices})`, y: bgY }}
        aria-hidden="true"
      />

      {/* Luxe overlays */}
      <div className="services-overlay" aria-hidden="true" />
      <div className="services-glow" aria-hidden="true" />

      <header className="services-header">
        <h2 id="services-title">Nos services</h2>

        {/* Sous-texte pro (et “24/7 sur réservation” ici, c’est plus crédible) */}
        <p className="services-subtitle">
          Gare • Aéroport • Longue distance • Business — <strong>7j/7 sur réservation</strong>
        </p>

        {/* SEO discret */}
        <span className="sr-only">
          Taxi Belfort : transferts gare de Belfort, aéroport Bâle-Mulhouse, longue distance,
          service business, réservation taxi.
        </span>
      </header>

      <div className="services-cards">
        {servicesData.map((service) => (
          <ServiceCard key={service.title} service={service} />
        ))}
      </div>
    </section>
  );
};

export default Services;



